import { axios } from "@/utils/request";

// type 0账号密码登录 1验证码登录
export function login(data) {
  return axios({
    url: "/home/login",
    method: "POST",
    data
  });
}

// 找回密码
export function resetPsd(data) {
  return axios({
    url: "/home/login/reset",
    method: "POST",
    data
  });
}

// 获取验证码
export function getSMS(params) {
  return axios({
    url: "/home/login/SMS",
    method: "GET",
    params
  });
}

// 获取二维码唯一id
export function getQR() {
  return axios({
    url: "/home/login/getQR",
    method: "POST"
  });
}

// 获取扫码登陆信息
export function getQrCodeStatus(qrcode) {
  return axios({
    url: `/home/login/getQrCodeStatus/${qrcode}`,
    method: "GET"
  });
}

// 退出登录
export function logout() {
  return axios({
    url: `home/logout`,
    method: "GET"
  });
}
